import React from "react";
import BackButton from "../../experience/generic/elements/backbutton/BackButton";

/**
 * Reusable page header with back button and title for billing screens.
 * Optional `actions` renders on the right (e.g. office selector).
 */
const PageHeader = ({ title, actions, billingAdminLogout, userData }) => (
  <div className="form-renderer-back-button billing-page-header">
    <div className="billing-page-header-title">
      {userData?.jobTitle !== "Billing Admin" && <BackButton />}
      <p>{title}</p>
    </div>
    {actions}
    {billingAdminLogout}
  </div>
);

export default PageHeader;
